// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__J3Ttx","inputDescription":"styles_inputDescription__1LHTg"};